import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classNames from 'classnames';

import SmsTab from './TabsModel/SmsTab';
import WhatsAppTab from './TabsModel/whatsApptab';
import EmailTab from './TabsModel/EmailTab';
import {
  AxiosAPI,
  getGroupID,
} from './../../../../../../../helpers/AxiosAPI';
import {
  gAPI_GuestMessagingReservation_CountByStatus
} from './../../../../../../../constants/APIs';
import { useSelector } from 'react-redux';

export default function SendMessagePanel({
  activeTab = 'sms',
  onClose,
  preFillPhoneNumber,
  propertyId,
  showStatusFilter = false,
  showPhoneNumber = false,
  reservationId,
  source,
  reservationData
}) {

  const { timeZone } = useSelector(({ settings }) => ({
    timeZone: settings.timeZone,
  }));

  const [currentTab, setCurrentTab] = useState(activeTab);

  const [totalCount, setTotalCount] = useState(0);
  const [countLoading, setCountLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  // when icon is clicked again, switch tab
  useEffect(() => {
    setCurrentTab(activeTab);
  }, [activeTab]);

  const fetchCountByStatus = async (status, channel) => {
    if (!status || !propertyId) return;

    try {
      setCountLoading(true);

      const res = await AxiosAPI({
        method: 'get',
        url:
          `${gAPI_GuestMessagingReservation_CountByStatus}` +
          `?propertyId=${propertyId}` +
          `&groupId=${getGroupID()}` +
          `&reservationStatus=${status}` +
          `&channel=${channel}` +
          `&timeZone=${timeZone}`,
      });

      setTotalCount(res.data?.totalCount || 0);
    } catch (e) {
      console.error('count-by-status error', e);
      setTotalCount(0);
    } finally {
      setCountLoading(false);
    }
  };

  return (
    <Modal
      isOpen
      toggle={onClose}
      wrapClassName="modal-right send-message-panel"
      backdrop='static'
    >
      <ModalHeader toggle={onClose} style={{ padding: "25.1px" }}>
        Send Message
      </ModalHeader>

      <ModalBody>
        {/* Tabs header */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classNames({ active: currentTab === 'sms' })}
              onClick={() => setCurrentTab('sms')}
              style={{ cursor: 'pointer' }}
            >
              SMS
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classNames({ active: currentTab === 'whatsapp' })}
              onClick={() => setCurrentTab('whatsapp')}
              style={{ cursor: 'pointer' }}
            >
              WhatsApp
            </NavLink>
          </NavItem>

          {/* <NavItem>
            <NavLink
              className={classNames({ active: currentTab === 'email' })}
              onClick={() => setCurrentTab('email')}
              style={{ cursor: 'pointer' }}
            >
              Email
            </NavLink>
          </NavItem> */}
        </Nav>

        {/* Tabs content */}
        <TabContent activeTab={currentTab} className="pt-3">
          <TabPane tabId="sms">
            <SmsTab
              preFillPhoneNumber={preFillPhoneNumber || ''}
              propertyId={propertyId}
              showStatusFilter={showStatusFilter}
              showPhoneNumber={showPhoneNumber}
              reservationId={reservationId}
              source={source}
              totalCount={totalCount}
              loadingCount={countLoading}
              onStatusChange={(status) => {
                setSelectedStatus(status);
                fetchCountByStatus(status, 'SMS');
              }}
              reservationData={reservationData}
            />
          </TabPane>

          <TabPane tabId="whatsapp">
            <WhatsAppTab
              preFillPhoneNumber={preFillPhoneNumber || ''}
              propertyId={propertyId}
              showStatusFilter={showStatusFilter}
              showPhoneNumber={showPhoneNumber}
              reservationId={reservationId}
              source={source}
              totalCount={totalCount}
              loadingCount={countLoading}
              onStatusChange={(status) => {
                setSelectedStatus(status);
                fetchCountByStatus(status, 'Whatsapp');
              }}
              reservationData={reservationData}
            />

          </TabPane>

          {/* <TabPane tabId="email">
            <EmailTab
            propertyId={propertyId}
             />
          </TabPane> */}
        </TabContent>
      </ModalBody>
    </Modal>
  );
}


